// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { CustomEvent } from "../../Utils/CustomEvents.js";
import { ColorPickerScreen } from "../screen/ColorPickerScreen.js";
import { TerceraButton } from "./TerceraButton.js";
import { ThemeManager } from "../misc/ThemeManager.js";

export let TerceraButtonColorPicker = TerceraButton.extend({
    data: function ()
    {
        return {
            width: 47,
            height: 23,
            terceraButtonStyle: TerceraButton.TerceraButtonStyle.ColorPicker,
            isColoringButton: true,
            coloringButtonColor: 'transparent',
            BackText: ''
        };
    },
});

TerceraButtonColorPicker.prototype.oninit = function ()
{
    TerceraButton.prototype.oninit.apply(this);
    this.on(TerceraButton.Events.onClick, this.onBtnClick);
    this.ColorChanged = new CustomEvent();
    this.transparentMask = ThemeManager.getImageFullUrl("darkNew/web_only/colorPicker/transparent_color.png");
    this.transparentMaskNoColor = ThemeManager.getImageFullUrl("darkNew/web_only/colorPicker/transparent_color_canselled.png");
    this.observe("coloringButtonColor", function (val)
    {
        if (val)
        {
            if (val.indexOf('rgba(') !== -1)
            {
                var valueA = parseFloat(val.split(',')[3]);
                if (valueA === 0)
                    this.set({ coloringButtonImage: this.transparentMaskNoColor });
                else
                    this.set({ coloringButtonImage: this.transparentMask });
            }
            else
                if (val === 'transparent')
                    this.set({ coloringButtonImage: this.transparentMaskNoColor });
                else
                    this.set({ coloringButtonImage: this.transparentMask });
        }
    });
};

TerceraButtonColorPicker.prototype.onBtnClick = function ()
{
    ColorPickerScreen.ShowScreen(
        this.lastMouseClickX,
        this.lastMouseClickY,
        this.get('coloringButtonColor'),
        this.onColorChanged.bind(this));
};

TerceraButtonColorPicker.prototype.onColorChanged = function (newColor)
{
    this.set('coloringButtonColor', newColor);
    this.fire(TerceraButtonColorPicker.Events.onColorChanged, newColor);
    if (this.ColorChanged) this.ColorChanged.Raise(this, newColor);
};

TerceraButtonColorPicker.Events =
{
    onColorChanged: 'onColorChanged'
};